import {MapContentLayer} from '../MapContentLayer';
import { FilterSpecification, LayerSpecification, Map, SymbolLayerSpecification } from 'maplibre-gl';
import {MapPreviewComponent} from '../../map-preview.component';
import { MapContentVectorSource } from '../MapContentVectorSource';

export class StormTrackArrowsLayer extends MapContentLayer {

  constructor(
    source: MapContentVectorSource,
  ) {
    super('storm-track-arrows-layer', source);
  }

  toLayerSpecification(): LayerSpecification {
    return {
      id: this.layerId,
      type: 'symbol',
      source: this.sourceRef.sourceId,
      'source-layer': 'track_geometry',
      filter: ['all', ['boolean', false]],
      layout: {
        'symbol-placement': 'line',
        'icon-image': MapPreviewComponent.TRACK_ARROW_IMAGE,
        'icon-rotate': 90,
        'icon-rotation-alignment': 'map',
        'icon-allow-overlap': true,
        'icon-ignore-placement': true
      },
      paint: {
      }
    } as SymbolLayerSpecification;
  }

  filterByTime(map: Map, timeFrom: number, timeTo: number) {
    // temporary disabled
    return;

    // startunixtime
    // endunixtime
    const filter: any[] = ['all'];
    if (!!timeFrom) {
      filter.push(['>=', ['get', 'startunixtime'], timeFrom]);
    }
    if (!!timeTo) {
      filter.push(['<=', ['get', 'endunixtime'], timeTo]);
    }

    map.setFilter(
      this.layerId,
      filter as FilterSpecification,
    );
  }
}
